"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.LOCALE_CONFIG = exports.DEFAULT_LOCALE = exports.DAYS_LABEL = void 0;
var DAYS_LABEL = 'days';
exports.DAYS_LABEL = DAYS_LABEL;
var LOCALE_CONFIG = {
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  hour12: false
};
exports.LOCALE_CONFIG = LOCALE_CONFIG;
var DEFAULT_LOCALE = 'en-GB';
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
var TRANSLATION = {
  min: 'min',
  secLeft: 'sec left',
  hours: 'hours'
};
exports.TRANSLATION = TRANSLATION;